function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.09928 9.61595L2.71528 9.99995L2.33128 9.61595L0.159057 7.44373C-0.0530195 7.23165 -0.0530195 6.88781 0.159057 6.67573C0.371134 6.46365 0.714978 6.46365 0.927054 6.67573L2.17222 7.9209L2.17222 0.543056C2.17222 0.243135 2.41536 1.05579e-07 2.71528 1.18689e-07C3.0152 1.31799e-07 3.25834 0.243135 3.25834 0.543056L3.25834 7.9209L4.50351 6.67573C4.71558 6.46365 5.05943 6.46365 5.2715 6.67573C5.48358 6.88781 5.48358 7.23165 5.2715 7.44373L3.09928 9.61595Z",
  fill: "#9492C4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.68863 0.383989L8.30464 -1.03717e-05L7.92064 0.383988L5.74841 2.55621C5.53634 2.76829 5.53634 3.11213 5.74841 3.32421C5.96049 3.53629 6.30433 3.53629 6.51641 3.32421L7.76158 2.07904L7.76158 9.45688C7.76158 9.7568 8.00471 9.99994 8.30464 9.99994C8.60456 9.99994 8.84769 9.7568 8.84769 9.45688L8.84769 2.07904L10.0929 3.32421C10.3049 3.53629 10.6488 3.53629 10.8609 3.32421C11.0729 3.11213 11.0729 2.76829 10.8609 2.55621L8.68863 0.383989Z",
  fill: "#9492C4"
});

var SvgReverseArrow = function SvgReverseArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReverseArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reverse-arrow.ce8d192b.svg";
export { ForwardRef as ReactComponent };